<template>
    <div class="J-card-body">
        <div class="J-card-item" v-for="(arraydataservice,index) in arraydataservices" :key="arraydataservice.length">
            <div class="J-card-item-content">
                <span class="J-card-item-amount" v-if="arraydataservice.amount==undefined">{{$set(arraydataservice, 'amount', 0)}}</span>
                <span class="J-card-item-amount" v-else-if="arraydataservice.amount!==0">{{arraydataservice.amount}}</span> 
                <img :src="arraydataservice.image[0].link" height="90" style="cursor:pointer" @click="checkVisble(index)" >
            </div>
            <h5>{{arraydataservice.name}}</h5>
            <ul class="J-list-price">
                <li class="J-list-price-item" v-for="(item,i) in arraydataservice.items" :key="i+1" @click="checkedItem(index,i,item)" :class="{'active':item.checked}">
                    <span v-if="i==0">
                        <i class="fas fa-check" v-if="item.checked===undefined">{{$set(item, 'checked', true)}}</i>
                        <i class="fas fa-check" v-else-if="item.checked==true"></i>
                    </span>
                    <span v-else>
                        <i class="" v-if="item.checked===undefined"></i>
                        <i class="fas fa-check" v-else-if="item.checked==true"></i>
                    </span>
                    <b>S/. {{item.price}}.00 </b> {{item.description}}

                    <div class="J-card-item-amount" v-if="item.amount==undefined">{{$set(item, 'amount', 0)}}</div>
                    <div class="J-card-item-amount" v-else-if="item.amount!==0">{{item.amount}}</div> 
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

import voucher from '@/components/partials/voucher'

import Cart from '@/models/cart.js'
//import Mapubicate from '@/components/Templates/Views/Mapbubicate.vue'

import {CartService,PaymentService} from "@/services";
import {CompanyStorage,CartStorage,OrderStorage,OrderDetailStorage} from '@/helpers/storage'


import {Payment,Order} from '@/models'
import moment from "moment"
export default {
    data(){
        return{
            tabs:[
                {title:'Detalle',active:true,checked:false},
                {title:'Pagar',active:false,checked:false},
                {title:'Targeta',active:false,checked:false},
                {title:'Trasaccion',active:false,checked:false},
                {title:'Efectivo',active:false,checked:false},
            ],
            tabforaddresstype:[
                {title:'addresspickup', active:false, checked:false},
                {title:'deliveryaddress', active:false, checked:false},
            ],
            total: 0.00,
            dataMount:[],
            dataYear:[],
            btnTransaction:true,
            arraydataservices:[],
            name:'n',
            cart:new Cart(),
            order: new Order(),
            payment:new Payment(),
            companyStorage:new CompanyStorage(),
            cartStorage:new CartStorage(),
            orderDetailStorage:new OrderDetailStorage(),
            orderStorage:new OrderStorage(),
            dataTypePayment:[
                {title:'Pago con tarjeta',active:true},
                {title:'Pago con transaccón',active:false},
                {title:'Pago con efectivo',active:false},
            ],
            transactions:[]
        }
    },
    
    computed:{
    },
    created:function(){
        this.arraydataservices=this.orderDetailStorage.get()||[];
    
        //this.checkedTotal();
        this.order=this.orderStorage.get()||new Order;
    },
    methods:{
        checkedItem:function(index,i,item){
            this.arraydataservices[index].items.forEach(element=>{
                this.$set(element,'checked',false);
            })
            this.$set(item,'checked',true);
        },
        isTabsActive:function(i){
            this.tabs.forEach(element => {
                element.active=false;
            });
            this.tabs[i].active=true;
        },
        checkedTotal:function(){
            this.arraydataservices.forEach(element=>{
                element.items.forEach((e)=>{
                    this.total=+e.amount*e.price;
                })
            });
        },
        checkVisble:function(index){
            //this.$set(this.arraydataservices[index], 'visible', true)
        },
        amount:function(sum,index){
            var result=this.arraydataservices[index].amount+sum;
            if(result<=0){
                this.addAmountItem(index,sum);
                this.$set(this.arraydataservices[index],'amount',0)
                this.addcart(index,true);
                return;
            }
            this.addAmountItem(index,sum);
            this.$set(this.arraydataservices[index],'amount',result)
            this.addcart(index);

        },
        addcart:function(index,splice=false){
            if(index!=-1){
                if(splice==true){
                    this.arraydataservices.splice(index,1)
                }
            }
            localStorage.setItem('cart',JSON.stringify(this.arraydataservices));
        },
        addAmountItem:function(i,sum){
            var find=this.arraydataservices[i].items.findIndex((e)=>e.checked==true);
            if(find!=-1){

                var amount=this.arraydataservices[i].items[find].amount==undefined?0:this.arraydataservices[i].items[find].amount;
                var total=sum+amount;
                if(total<=0){
                    this.$set(this.arraydataservices[i].items[find],'amount',0)
                    return;
                }
                this.$set(this.arraydataservices[i].items[find],'amount',total)
                var serivices=this.arraydataservices[i].items[find];
                this.total=+serivices.amount*serivices.price
            }
        },
    },
    components: { voucher,},
}


</script>